module.exports = __webpack_public_path__ + "media/images/get-involved/codeclub-a889240a28f52cadd4b113c3b7b9fe11.svg";